module.exports = __webpack_public_path__ + "42518c141cb50df78e7e0d5ccb701c2f.png";